import React, { useEffect, useState } from 'react'
import { PreviewModel } from './types/previewTypes'
import { useDispatch } from 'react-redux'
import errorCatcher from '../../utils/errorCatcher'
import previewEnum from '../../enums/previewEnum'
import AlertDetails from '../alert/Details'
import NewsDetails from '../news/details/Details'
import DetailFooterPage from '../footer/DetailFooterPage'
import ServiceDetails from '../services/components/details/ServiceDetails'
import { useLocation } from 'react-router'

const INITIAL_STATE: PreviewModel = {
	type: '',
	content: ''
}
const FETCH_PREVIEW = 'get_preview'

const Preview = () => {
	const location = useLocation()
	const [preview, setPreview] = useState<PreviewModel>(INITIAL_STATE)
	const dispatch = useDispatch()

	useEffect(
		() => {
			const path = location.search.split('&')
			const language = path[0].substr(1).split('=')[1]
			const id = path[1].split('=')[1]

			fetch(`/api/ec_${process.env.REACT_APP_TARGET}/information/getPreview?language=${language}&id=${id}`)
				.then(
					(response: Response) => response.json()
						.then(
							(contentResponse: PreviewModel) => setPreview(contentResponse)
						)
				)
				.catch(
					(error: any) => dispatch(
						errorCatcher(error, FETCH_PREVIEW)
					)
				)
		}, [dispatch, location.search]
	)

	const contentToDisplay = () => {
		const content = preview.content

		switch (preview.type) {
			case previewEnum.alert:
				return <AlertDetails content={content} />

			case previewEnum.actualite_marketing:
			case previewEnum.actualite_exploitation:
				return <NewsDetails content={content} />

			case previewEnum.footer:
				return <DetailFooterPage content={content} />

			case previewEnum.service:
				return <ServiceDetails isPreview content={content} />

			default:
				return <AlertDetails content={content} />
		}
	}

	if (preview.type) {
		return (
			<>
				{contentToDisplay()}
			</>
		)
	} else {
		return (
			<>
			</>
		)
	}
}

export default Preview
